import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { listCommunity, listReligions } from "../../models/fieldSettings";
import {
  BLOOD_GROUPS,
  decimalKeyPress,
  integerIndMobile,
  lowerCase,
  momentDate,
  upperCase,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const StepOne = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [maritalStatus, setMaritalStatus] = useState("");
  const [fatherPhone, setFatherPhone] = useState("");
  const [motherPhone, setMotherPhone] = useState("");
  const [annualIncome, setAnnualIncome] = useState("");

  const [religions, setReligions] = useState([]);
  const [community, setCommunity] = useState([]);

  useEffect(() => {
    listCommunity().then((res) => res && setCommunity(res));
    listReligions().then((res) => res && setReligions(res));

    if (props.dataSource) {
      setFatherPhone(props.dataSource.fatherphone);
      setMotherPhone(props.dataSource.motherPhone);
      setAnnualIncome(props.dataSource.annualincome);
    }
  }, [props.dataSource]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      Toast.show({ content: "Please fill all the required fields" });
      return;
    }
    if (!Number(annualIncome) || parseFloat(annualIncome) < 1) {
      Toast.show({ content: "Enter valid annual income" });
      return;
    }
    Dialog.confirm({
      content: "Do you want to update?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        updateProfilee(form);
      },
    });
  };

  const updateProfilee = (form) => {
    context.setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.UPDATE_PROFILE_STEP_ONE, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          if (props.onSuccess) props.onSuccess();
          Toast.show({
            content: res["data"].message || "Updated",
            icon: "success",
          });
          context.setStorage("setp_one", "yes");
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        context.setLoader(false);
      });
  };

  const maxDate = () => {
    let y = momentDate(new Date(), "YYYY") - 16;
    let d = momentDate(new Date(), "DD");
    let m = momentDate(new Date(), "MM");
    return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
  };

  const studentData = (fieldName) => {
    let d = context.getStorage("update_stu_data");
    if (d) d = JSON.parse(d);
    return d?.[fieldName];
  };

  const field = (fieldName) => {
    let m = props.dataSource;
    return m?.[fieldName];
  };

  return (
    <>
      <Form
        action=""
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="uuid" value={studentData("uuid")} />
        <input
          type="hidden"
          name="registerno"
          value={studentData("registerno")}
        />

        <Card>
          <Card.Header className="card-header-bg fw-bold text-uppercase">
            Basic Information
          </Card.Header>
          <Card.Body>
            <Row className="border-bottom pb-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Gender <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  as="select"
                  size="sm"
                  className="fw-bold"
                  name="gender"
                  required
                >
                  <option value="">-Select-</option>
                  <option
                    value="male"
                    selected={
                      lowerCase(field("gender")) == "male" ? "selected" : ""
                    }
                  >
                    Male
                  </option>
                  <option
                    value="female"
                    selected={
                      lowerCase(field("gender")) == "female" ? "selected" : ""
                    }
                  >
                    Female
                  </option>
                </Form.Control>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  DOB <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="date"
                  size="sm"
                  className="fw-bold"
                  name="dob"
                  max={maxDate()}
                  defaultValue={field("dob")}
                  required
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Community <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  as="select"
                  size="sm"
                  className="fw-bold"
                  name="community"
                  required
                >
                  <option value="">-Select-</option>
                  {community.map((item) => (
                    <option
                      value={item.id}
                      selected={field("community") == item.id ? "selected" : ""}
                    >
                      {upperCase(item.community)}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Caste <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="caste"
                  defaultValue={field("caste")}
                  required
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Religion <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  as="select"
                  size="sm"
                  className="fw-bold"
                  name="religion"
                  required
                >
                  <option value="">-Select-</option>
                  {religions.map((item) => (
                    <option
                      value={item.id}
                      selected={item.id == field("religion") ? "selected" : ""}
                    >
                      {item.religion}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Nationality <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  as="select"
                  size="sm"
                  className="fw-bold"
                  name="nationality"
                  required
                >
                  <option value="">-Select-</option>
                  <option
                    value="indian"
                    selected={
                      lowerCase(field("nationality")) == "indian"
                        ? "selected"
                        : ""
                    }
                  >
                    Indian
                  </option>
                  <option
                    value="others"
                    selected={
                      lowerCase(field("nationality")) == "others"
                        ? "selected"
                        : ""
                    }
                  >
                    Others
                  </option>
                </Form.Control>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Mother Tongue <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="mothertongue"
                  defaultValue={field("mothertongue")}
                  required
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Blood Group <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  as="select"
                  size="sm"
                  className="fw-bold"
                  name="blood_group"
                  required
                >
                  <option value="">-Select-</option>
                  {BLOOD_GROUPS.map((item) => (
                    <option
                      value={item}
                      selected={field("blood_group") == item ? "selected" : ""}
                    >
                      {item}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Marital Status
        </div>
        <div className="container py-2">
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Marital Status <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                as="select"
                size="sm"
                className="fw-bold"
                name="maritalstatus"
                onChange={(e) => setMaritalStatus(e.target.value)}
                required
              >
                <option value="">-Select-</option>
                <option
                  value="single"
                  selected={
                    lowerCase(field("maritalstatus")) == "single"
                      ? "selected"
                      : ""
                  }
                >
                  Single
                </option>
                <option
                  value="married"
                  selected={
                    lowerCase(field("maritalstatus")) == "married"
                      ? "selected"
                      : ""
                  }
                >
                  Married
                </option>
              </Form.Control>
            </Col>
          </Row>

          {maritalStatus == "married" && (
            <div>
              <Row className="mt-2">
                <Col md={4} sm={4} xs={4}>
                  <label>
                    Partner Name <span className="text-danger"></span>
                  </label>
                </Col>
                <Col md={8} sm={8} xs={8}>
                  <Form.Control
                    type="text"
                    size="sm"
                    className="fw-bold"
                    name="partnername"
                    defaultValue={field("partnername")}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={4} sm={4} xs={4}>
                  <label>
                    Partner Phone <span className="text-danger"></span>
                  </label>
                </Col>
                <Col md={8} sm={8} xs={8}>
                  <Form.Control
                    type="number"
                    size="sm"
                    className="fw-bold"
                    name="partnermobile"
                    defaultValue={field("partnermobile")}
                  />
                </Col>
              </Row>
            </div>
          )}
        </div>
        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Details about Father
        </div>
        <div className="container py-2">
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Father Name <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="fathername"
                defaultValue={field("fathername")}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Occupation <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="fatheroccupation"
                defaultValue={field("fatheroccupation")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Contact No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="fatherphone"
                onChange={(e) => setFatherPhone(e.target.value)}
                value={fatherPhone}
                onKeyPress={integerIndMobile}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Email Id <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="email"
                size="sm"
                className="fw-bold"
                name="father_email"
                defaultValue={field("father_email")}
                required
              />
            </Col>
          </Row>
        </div>

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Details about Mother
        </div>
        <div className="container py-2">
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Mother Name <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="mothername"
                defaultValue={field("mothername")}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Occupation <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="motheroccupation"
                defaultValue={field("motheroccupation")}
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Contact No <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="motherphone"
                onChange={(e) => setMotherPhone(e.target.value)}
                value={motherPhone}
                onKeyPress={integerIndMobile}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Email Id <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="email"
                size="sm"
                className="fw-bold"
                name="mother_email"
                defaultValue={field("mother_email")}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Family Annual Income
        </div>
        <div className="container py-2">
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Annual Income <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="annualincome"
                value={annualIncome}
                onKeyPress={decimalKeyPress}
                onChange={(e) => setAnnualIncome(e.target.value)}
                required
              />
            </Col>
          </Row>
        </div>

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Details about Guardian
        </div>
        <div className="container py-2">
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Guardian Name <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="guardian_name"
                defaultValue={field("guardian_name")}
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Occupation <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="guardian_occupation"
                defaultValue={field("guardian_occupation")}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Contact No <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="guardian_mobile"
                defaultValue={field("guardian_mobile")}
                onKeyPress={integerIndMobile}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Email Id <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="email"
                size="sm"
                className="fw-bold"
                name="guardian_email"
                defaultValue={field("guardian_email")}
              />
            </Col>
          </Row>
        </div>

        <div className="container py-3">
          <Row>
            <Col md={12}>
              <Button
                type="submit"
                variant="warning"
                className="w-100"
                size="lg"
                disabled={fatherPhone && fatherPhone.length != 10}
              >
                Save & Continue
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
    </>
  );
};
export default StepOne;
